module.exports = __webpack_public_path__ + "fa7baf1f63e4fc08db4b4932dbfb953f.woff2";